import { render, staticRenderFns } from "./PropertyTitle.vue?vue&type=template&id=bfdb0518&scoped=true"
import script from "./PropertyTitle.vue?vue&type=script&lang=js"
export * from "./PropertyTitle.vue?vue&type=script&lang=js"
import style0 from "./PropertyTitle.vue?vue&type=style&index=0&id=bfdb0518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdb0518",
  null
  
)

export default component.exports